module.exports = __webpack_public_path__ + "img/kinoerlebnis.a9b97ec1.png";